export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/operations.worker.6d7449a5.worker.js");
}
